import {computed, reactive, Ref, toValue, watchEffect} from 'vue';
import {createSharedComposable} from '@vueuse/core';
import {usePage} from '@inertiajs/vue3';
import {MaybeReadonlyRefOrGetter} from '@floating-ui/vue';

export interface Features {
  ddtLlmOptions: boolean;
  globalMathExpressions: boolean;
  criteriaGradeExport: boolean;
  taskEditorAgent: boolean;
  taskResponseExamples: boolean;
}

export const useFeatureFlags = createSharedComposable(
  (props?: MaybeReadonlyRefOrGetter<Record<string, any>>) => {
    // Default to page props
    props = props || (() => usePage().props);

    const featureFlags = reactive<Partial<Features>>({});

    watchEffect(
      () => {
        const resolvedProps = toValue(props);

        // We get whatever feature flags we find on the props. We iterate only over what's in the props,
        // so anything that gets sent fresh with the response will override existing flags, but anything
        // that's missing will stay the same from the latest value that was seen.
        const features = {
          ...resolvedProps?.__features,
        } as Partial<Features>;

        for (const [name, enabled] of Object.entries(features)) {
          featureFlags[name as keyof Features] = enabled;
        }
      },
      {flush: 'sync'}
    );

    return {featureFlags};
  }
);
